export default {
  isLoading: false,
  listaPrestaciones: [],
  listaPrestacionesFiltrada: [],
  showNoData: false,
  filtrosPrestaciones: null,
  mainFilters: [
    {
      index: 1, Icon: "2", name: "Sin Documentacion", column: "EstadoDocumentacion", value: { text: "Sin Documentacion", value: "Sin Documentacion" },
    },
  ],
  totalPrestaciones: 0,
  selectedTipoPrestacion: {
    index: 1, Icon: "2", name: "Sin Documentacion", column: "EstadoDocumentacion", value: { text: "Sin Documentacion", value: "Sin Documentacion" },
  },
  isDownloadLoading: false,
  showHideForm: false,
  isOpenModalBorrador: false,
  isOpenModalContinue: false,
  isOpenModalDelete: false,
  editingDraft: false,
  activeStep: 1,
  lastStep: 4,
  lastCompletedStep: 1,
  steps: [
    {
      id: 1, text: "Información del trabajador", subtext: "Ingresa la información del trabajador que recibirá la prestación económica",
    },
    {
      id: 2, text: "Información laboral", subtext: "Ingresa la información laboral del trabajador que recibirá la prestación",
    },
    {
      id: 3, text: "Información previsional", subtext: "Ingresa la información previsional del trabajador",
    },
    {
      id: 4, text: "Enviar documentación", subtext: "Envío de la documentación",
    },

  ],
  isModified: false,
  listaDocumentosIngresados: [],
  IdDraft: null,
  jsonData: {
    Id: null,
    idFinancialBenefit: null,
    monthsDisplay: [],

    middleStepsEnabled: true,
    fechaSiniestro: null,
    formInfoTrabajador: {},
    formInfoLaboral: {},
    formInfoPrevisional: {
      checkAllMonth: false,
    },
    formEnvioDocumento: {},
    currentStep: 1,
    step1Complete: false,
    step2Complete: false,
    step3Complete: false,
    step4Complete: false,
    container: null,
  },


};

